import React, { Component } from "react";
import Tooltip from "./Tooltip";
import { isValid } from "../shared/utils";
import { connect } from "react-redux";

class LuggageTooltip extends Component {
	constructor() {
		super();
		this.state = { showTooltip: false };
		this.toogleTooltip = this.toogleTooltip.bind(this);
	}

	setIconMessage(luggage) {
		let iconMessage = [],
			handBagMessage = { message: "", icon: "" },
			{ carryOn, checked } = luggage;

		handBagMessage.icon = "icon-yes";
		handBagMessage.message = (
			<span>
				Você pode levar uma bagagem de mão (até <strong>{carryOn.weight}Kg</strong>){" "}
				{checked.prices[0] === 0 ? (
					<span className="no-padding">
						e também pode despachar <strong>{checked.prices.length}</strong>{" "}
						{checked.prices.length === 1 ? "bagagem" : "bagagens"} (até{" "}
						<strong>{checked.weight}Kg</strong>) grátis.<br />
						<br />
						<strong>
							Mas, atenção! Para fazer o despacho, não se esqueça de incluir a opção Bagagem durante
							o processo de compra.
						</strong>
					</span>
				) : (
					"grátis."
				)}
			</span>
		);

		iconMessage.push(handBagMessage);

		if (checked.prices[0] !== 0) {
			let dispatchMessage = this.dispatchLugagge();
			iconMessage.push(dispatchMessage);
		}

		return iconMessage;
	}

	dispatchLugagge() {
		let iconMessage = { message: "", icon: "" };

		iconMessage.message = (
			<span>
				Atenção! Essa passagem não inclui bagagem despachada. Deseja incluir? Informe-se na
				companhia aérea
			</span>
		);
		iconMessage.icon = "icon-no";

		return iconMessage;
	}

	generalMessage(airline, international, luggage) {
		if (international) {
			return (
				<p>
					Após a compra,{" "}
					<strong>confira as regras para despachar sua bagagem em viagens internacionais</strong> no
					site da{" "}
					<span className="text-uppercase float-none">
						<strong>{airline}</strong>
					</span>.
				</p>
			);
		}

		let { checked } = luggage,
			luggageTipe =
				checked.prices.length === 0
					? "buyOnCompanny"
					: checked.prices[0] === 0 ? "included" : "buyOnMaxmilhas";

		switch (luggageTipe) {
			case "buyOnMaxmilhas":
				return (
					<p>
						Precisa despachar bagagem? Você poderá incluir sua bagagem despachada{" "}
						<strong>no processo de compra</strong> da sua passagem.
					</p>
				);

			case "buyOnCompanny":
				return (
					<p>
						Vai despachar bagagem? Caso precise, compre sua bagagem despachada com a companhia
						aérea, <strong>durante o processo de check-in online.</strong> Ele poderá ser realizado
						após a <strong>confirmação da emissão da sua passagem</strong>, a partir de{" "}
						<strong>7 dias antes do voo.</strong>
					</p>
				);

			case "included":
				return (
					<p>
						Dúvidas? Após sua compra, <strong>confira as regras de bagagem despachada</strong> no
						site da companhia aérea.
					</p>
				);
		}
	}

	setTooltip(content) {
		let tooltip = {
			iconMessage: [],
			message: "",
			button: {
				text: "Entendi"
			}
		};

		let { luggage, airline } = content;

		tooltip.iconMessage = this.props.isInternational ? [] : this.setIconMessage(luggage);
		tooltip.message = this.generalMessage(airline, this.props.isInternational, luggage);

		return tooltip;
	}

	toogleTooltip() {
		let { showTooltip } = this.state;

		!showTooltip ? this.closeOpenedLuggageTooltip() : null;

		this.setState({ showTooltip: !showTooltip });
	}

	closeOpenedLuggageTooltip() {
		var openTooltip = document.querySelector(".tooltip-component:not(.hidden)");

		if (isValid(openTooltip)) {
			openTooltip.querySelector(".icon-close").click();
		}
	}

	componentDidUpdate(prevProps) {
		return prevProps.show !== this.props.show ? this.toogleTooltip() : null;
	}

	render() {
		if (this.props.content) {
			const tooltip = this.setTooltip(this.props.content);

			return (
				<Tooltip
					otherClasses={"luggage-tooltip"}
					key={this.props.childId}
					content={tooltip}
					display={this.state.showTooltip}
					closeTooltip={this.toogleTooltip}
				/>
			);
		}

		return null;
	}
}

export default LuggageTooltip;
